import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=5a605b1a&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=5a605b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a605b1a",
  null
  
)

export default component.exports